<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.mobile" v-model="dialog" scrollable width="1280">
    <v-card>
      <v-card-title class="amber darken-1 white--text">
        <span class="text-uppercase">{{ classData.code }} ({{ getSlotDate }})</span>
        <v-spacer />
        <v-icon color="white" @click="dialog = !dialog">close</v-icon>
      </v-card-title>
      <v-card-text>
        <class-attendance-form
          v-if="shouldAllowEdit"
          ref="classAttendanceForm"
          :slotData="slotData"
          :classData="classData"
          :attendances="attendances"
        ></class-attendance-form>
        <p v-else class="update-forbiden-noti">
          {{ forbidenMessage }}
        </p>
      </v-card-text>
      <v-divider />
      <v-card-actions v-if="shouldAllowEdit" class="pa-4">
        <p class="error-message">
          {{ formErrorMessage }}
        </p>

        <v-spacer></v-spacer>
        <v-btn style="min-width: 96px" color="primary" @click="save()">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ClassAttendanceForm from '@/modules/class/attendance/ClassAttendanceForm.vue'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    ClassAttendanceForm
  },
  props: {
    slotData: Object,
    classData: Object,
    attendances: Object,
    data: Object,
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      formErrorMessage: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['profile', 'user']),
    getSlotDate() {
      return moment(this.slotData.startTime).format('HH:mm DD/MM/yyyy')
    },
    forbidenMessage() {
      const timeDiff = moment().diff(moment(this.slotData.startTime), 'minute')
      if (timeDiff < -15) {
        return 'Chưa đến giờ điểm danh, chỉ có thể điểm danh sớm nhất từ 15p trước buổi học'
      } else if (timeDiff > 20) {
        return 'Đã quá giờ điểm danh, chỉ có thể điểm danh muộn nhất 20 phút sau khi bắt đầu buổi học'
      } else {
        return ''
      }
    },
    shouldAllowEdit() {
      const roleType = this.user.role.type
      const timeDiff = moment().diff(moment(this.slotData.startTime), 'minute')

      return (
        ['departmentmanager', 'super_admin', 'education_manager'].includes(roleType) ||
        (timeDiff < 20 && timeDiff > -15)
      )
    }
  },
  methods: {
    ...mapActions('classDetail', ['fetchClass', 'updateClass', 'createAttendances']),
    async save() {
      let atts = this.$refs.classAttendanceForm.getData()
      const isFormCompleted = atts.every(a => a.status)
      if (!isFormCompleted) {
        this.formErrorMessage = 'Vui lòng điền đầy đủ thông tin cho tất cả sinh viên'
        return
      }
      this.$loading.active = true
      this.formErrorMessage = ''
      try {
        await this.createAttendances(atts.filter(a => a.status))
      } catch (error) {
        console.error(error)
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
      this.dialog = false
    },
    open() {
      this.dialog = true
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
<style scoped>
.update-forbiden-noti {
  font-size: 1.5em;
  padding: 40px 0;
  text-align: center;
  margin-bottom: 0px;
}
.error-message {
  color: red;
}
</style>
